export enum ErrorCode {
  INVALID_SIGNATURE = 'INVALID_SIGNATURE',
  SECRET_NOT_CONFIGURED = 'SECRET_NOT_CONFIGURED',
  MISSING_SIGNATURE = 'MISSING_SIGNATURE'
}

